import React from "react";
import UserAvatarBadge from "./UserAvatarBadge";

export const mappingPillStyle = (mapping, fallbackSite) => {
  const site = String(mapping?.site || fallbackSite || "VIG").toUpperCase();
  const specific = mapping?.specificity === "specific";
  if (site === "BOT") {
    return {
      backgroundColor: specific ? "#8b1e1e" : "#f5cccc",
      color: specific ? "#fff" : "#5f1717",
      borderColor: specific ? "#8b1e1e" : "#eaa9a9",
    };
  }
  return {
    backgroundColor: specific ? "#174f88" : "#cfe4fb",
    color: specific ? "#fff" : "#16426d",
    borderColor: specific ? "#174f88" : "#9ec6ef",
  };
};

export const mappingLabel = (mapping) => {
  const path = mapping?.categoryPath || mapping?.categoryLabel || mapping?.externalCategoryId || mapping?.categoryId;
  return `${path}${mapping?.isDefaultCandidate ? " - default" : ""}`;
};

export const groupMappingsByRule = (mappings) =>
  (Array.isArray(mappings) ? mappings : []).reduce((groups, mapping) => {
    const ruleId = String(mapping?.ruleId || "unknown");
    if (!groups[ruleId]) {
      groups[ruleId] = {
        ruleId,
        name: mapping?.ruleDescription || mapping?.ruleKey || `Regola #${ruleId}`,
        createdBy: mapping?.createdBy,
        updatedBy: mapping?.updatedBy,
        mappings: [],
      };
    }
    groups[ruleId].mappings.push(mapping);
    return groups;
  }, {});

function WebCategoryMappingCards({
  mappings,
  rowKey = "mapping",
  site,
  selectedRuleId = null,
  onSelect = null,
  disabled = false,
}) {
  const groups = Object.values(groupMappingsByRule(mappings));
  if (!groups.length) return <span className="gray">Nessuna map compatibile</span>;
  return (
    <div className="flex flex-column web-category-mapping-cards">
      {groups.map((group) => {
        const selected = Number(selectedRuleId) === Number(group.ruleId);
        const valid = group.mappings.some((mapping) => mapping?.valid !== false);
        return (
          <div
            key={`${rowKey}-${group.ruleId}`}
            className={`ba b--black-10 br2 pa2 mb2 web-category-mapping-card${selected ? " web-category-mapping-card--selected" : ""}`}
          >
            <div className="flex items-center justify-between mb1">
              <div className="f7 fw6 pr2" title={"Regola #" + group.ruleId}>{group.name}</div>
              <UserAvatarBadge username={group.updatedBy} fallbackUsername={group.createdBy} size={26} />
            </div>
            <div className="flex flex-wrap">
              {group.mappings.map((mapping, index) => (
                <span
                  key={`${rowKey}-${mapping.ruleId}-${mapping.site || site}-${mapping.externalCategoryId || mapping.categoryId}-${index}`}
                  className="br-pill ph2 pv1 mr2 mb2 f7 ba"
                  style={mappingPillStyle(mapping, site)}
                  title={`Regola ${mapping.ruleId}${mapping.ruleDescription ? ` - ${mapping.ruleDescription}` : ""}`}
                >
                  {mappingLabel(mapping)}
                </span>
              ))}
            </div>
            {onSelect ? (
              <button
                type="button"
                className={`alignment-button mt1 ${selected ? "alignment-button--primary" : "alignment-button--secondary"}`}
                disabled={disabled || selected || !valid}
                aria-pressed={selected}
                onClick={() => onSelect(Number(group.ruleId))}
              >
                {selected ? "Mappatura selezionata" : valid ? "Usa questa mappatura" : "Categorie non valide"}
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default WebCategoryMappingCards;
